export default __webpack_public_path__ + "static/media/jill2.73375e59.jpg";